
import axios from "axios";
import { store } from '../store';
import {router} from "../helpers";
import {i18n} from "../i18n";

export const organisationService = {
    register,
    update
};

function register(organisationName, organisationPhone, organisationCategory, affiliate_partner, postcode, address1, address2, town, county, country, name, email, email_confirmation, mobile, password, password_confirmation, recaptchaToken, latitude, longitude, terms, brand) {

    let sms = mobile.replace('+440', '+44')

    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient.get('/sanctum/csrf-cookie').then(() => {
        return apiClient
            .post('/register', {
                organisation_name: organisationName,
                organisation_phone: organisationPhone,
                organisation_category: organisationCategory,
                affiliate_partner: affiliate_partner,
                postcode: postcode,
                address1: address1,
                address2: address2,
                town: town,
                county: county,
                country: country,
                admin_name: name,
                email: email,
                email_confirmation: email_confirmation,
                mobile: sms,
                password: password,
                password_confirmation: password_confirmation,
                recaptcha_token: recaptchaToken,
                latitude: latitude,
                longitude: longitude,
                terms: terms,
                brand: brand
            })
            .then(response => {

                // registration successful
                if (response.status === 201 && response.data) {
                    if (response.data.data.roles && response.data.data.roles.includes('user')) {
                        store.commit('loggedIn')
                    } else {
                        console.log('not authorised')
                        return Promise.reject('not authorised');
                    }
                }

                return response.data.data;
            })
            .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    if (error.response.status === 422) {

                        // store server side validation errors
                        return store.dispatch('validationErrors', error.response.data.errors, {root: true}).then(response => {
                            return Promise.reject('check form for errors');
                        });

                    } else {
                        return Promise.reject(error);
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else if (error.message) {
                    // Something happened in setting up the request that triggered an Error
                    console.log(error.message);
                } else {
                    // The login was rejected due to incorrect role
                    return Promise.reject(error);
                }
            });
    });
}

function update(id, name, phone, organisation_category_id, affiliate_partner, postcode, address1, address2, town, county, country, latitude, longitude, password, picture) {
    let apiClient = axios.create({
        baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
        headers: {'Accept-Language': i18n.locale},
        withCredentials: true,
    });

    return apiClient
        .patch('/api/organisations/' + id, {
            name: name,
            phone: phone,
            category: organisation_category_id,
            affiliate_partner: affiliate_partner,
            postcode: postcode,
            address1: address1,
            address2: address2,
            town: town,
            county: county,
            country: country,
            latitude: latitude,
            longitude: longitude,
            password: password,
            picture: picture
        })
        .then(response => {

            if (response.status === 200 && response.data) {

                // update local storage
                // let user = JSON.parse(localStorage.getItem('user'));
                // user.admin_for_organisations[0] = response.data.data
                // localStorage.setItem('user', JSON.stringify(user));

                return response.data.data;
            }


        })
        .catch(function (error) {
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                // console.log(error.response.data);
                // console.log(error.response.status);
                // console.log(error.response.headers);
                if (error.response.status === 422) {

                    // store server side validation errors
                    return store.dispatch('validationErrors', error.response.data.errors, { root: true }).then(response => {
                        return Promise.reject('check form for errors');
                    });

                }
                else {
                    return Promise.reject(error);
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else if (error.message) {
                // Something happened in setting up the request that triggered an Error
                console.log(error.message);
            } else {
                // The request was rejected due to incorrect role
                return Promise.reject(error);
            }
        });
}

